module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-24.42793d6d.png";